import { TeamTypes } from '@cbinsights/adminservice/adminservice';
import { request } from 'client/modules/common/utils/request';

export const getTeamTypes = (): Promise<TeamTypes> =>
  request({
    url: '/service/adminservice/GetTeamTypes',
  }).then((r) => r.body);
